import { getCurrentInstance } from '@/util'
import Token from '@/di/di.token'

export default function useDI() {
  const instance = getCurrentInstance()
  const container = instance.proxy.$di
  return {
    container,
    Token,
  }
}
